export default __webpack_public_path__ + "static/media/logo.41354b30.png";